<template>
  <div class="test-playground">
    <OpenHour v-model="time" />
    {{ time }}
  </div>
</template>

<script>
import OpenHour from "@/components/OpenHour";

export default {
  components: {
    OpenHour,
  },
  data() {
    return {
      time: [],
    };
  },
  methods: {
    onNew(value) {
      this.formData = value;
    },
    onChange(position) {
      this.position = position;
    },
  },
};
</script>

<style scoped>
.test-playground {
  background-color: #000;
  color: #fff;
  padding: 100px;
  min-height: calc(100vh - 60px);
}
</style>
